import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { XLg } from 'react-bootstrap-icons';
import { selectIsClient } from '../../redux/selectors';
import OnboardingDeck from '../OnboardingDeck';

const LS_KEY = 'skusavvy_onboarding_seen';

export default function OnboardingDeckModal() {
  const isClient = useSelector(selectIsClient);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isClient) return;
    try {
      if (!localStorage.getItem(LS_KEY)) {
        setVisible(true);
      }
    } catch {}
  }, [isClient]);

  const dismiss = useCallback(() => {
    setVisible(false);
    try {
      localStorage.setItem(LS_KEY, '1');
    } catch {}
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#191923',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <button
        onClick={dismiss}
        aria-label="Close onboarding guide"
        style={{
          position: 'absolute',
          top: 14,
          right: 16,
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '0.4em',
          background: 'rgba(36,36,50,0.92)',
          border: '1px solid #44445f',
          borderRadius: '999px',
          padding: '0.35em 0.9em',
          color: '#babace',
          fontFamily: "'Inter', sans-serif",
          fontSize: 12,
          fontWeight: 500,
          cursor: 'pointer',
          backdropFilter: 'blur(6px)',
          letterSpacing: '0.01em',
        }}>
        <XLg size={11} />
        Skip for now
      </button>
      <div style={{ flex: 1, position: 'relative' }}>
        <OnboardingDeck />
      </div>
    </div>
  );
}
